import React, { useEffect, useState } from 'react'
import './play-head-mobile.styles.scss'

import { useSelector } from 'react-redux';
import UserDropdown from './play-user-dropdown.component';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import gamably_icon_grey from '@/assets/icon-greyscale.png';
import ShoppingCartIcon from './shopping-cart-icon.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { formatNumber } from '@/utils/formatNumber';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBriefcase, faFlag, faGem, faHome, faRectangleList, faShoppingCart, faToolbox, faUserSecret, faX } from '@fortawesome/free-solid-svg-icons';
import PlayerSideMenu from '../side-menu.component';

const PlayHeadBarMobile = ({ 
    gameData, 
    playerData,
    playerActivity,
    gameElements
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const currentUser = useSelector(state => state.userData.currentUser);
    const userProfile = useSelector(state => state.userData.userProfile);
    const shoppingCart = useSelector(state => state.userData.shoppingCart);
    const [ showDropdown, setShowDropdown ] = useState(false);
    const [ menuOpen, setMenuOpen ] = useState(false);
    const [ pageTitle, setPageTitle ] = useState(null);
    const [ rewardCount, setRewardCount ] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setMenuOpen(false);
    }, [location])

    useEffect(() => {
        if (!playerActivity || !playerData) return;
        let count = Object.values(playerActivity).filter(a => 
            (a.display === 'reward' ||
            a.display === 'prizepack' ||
            a.display === 'achievement' ||
            a.display === 'purchase') &&
            playerData?.newStuff.includes(a.id)
        ).length;
        setRewardCount(count);
    }, [playerActivity, playerData])

    return (
        <div className={`play-head-bar-mobile__container ${screenSize}`}>
            <div className="logo-container">
                <button 
                    className='g-button text-only' 
                    onClick={() => setMenuOpen(!menuOpen)}>
                    <FontAwesomeIcon icon={faBars} size='2x' />
                </button>
                <Link to={`/play/${gameData.path}`} >
                    <ImageContainer src={gameData.icon} alt="Logo" className="logo" />
                </Link>
            </div>
            {/* <SearchContainer setShowSearchModal={setShowSearchModal} location='head-bar' /> */}
            <div className='head-menu-box'>
                <div className='head-menu-flex'>
                    <div className='head-menu'>
                        {/* <div className='head-menu-item' onClick={() => navigate('/coach')}>
                            Coach Home
                        </div>
                        <div className='menu-spacer'></div>
                        <div className='head-menu-item' onClick={() => navigate('/manage')}>
                            Manage Org
                        </div>
                        <div className='menu-spacer'></div>
                        <div className='head-menu-item' onClick={() => setShowMyOrgs(true)}>
                            Switch Organization
                        </div>
                        <div className='menu-spacer'></div> */}
                        {
                            (shoppingCart && Object.values(shoppingCart).length > 0) &&
                            <Link to={`/play/${gameData.path}/marketplace/shoppingcart`}>
                                <button 
                                    className='g-button text-only' >
                                    <ShoppingCartIcon cart={shoppingCart} />
                                </button>
                            </Link>
                        }
                        {
                            (   
                                // screenSize !== 'mobile' &&
                                playerData && 
                                gameData.access.includes('points')
                            ) &&
                            <Link to={`/play/${gameData.path}/myxpearnings`}>
                                <button 
                                    className='count-div g-button small-btn points-div' >
                                    <ImageContainer 
                                        src='/images/xp.png' 
                                        className='icon' 
                                    />
                                    <div className='count'>
                                        {formatNumber(playerData.points)}
                                    </div>
                                </button>
                            </Link>
                        }
                        {
                            (
                                // screenSize !== 'mobile' &&
                                playerData && 
                                gameData.access.includes('currency')
                            ) &&
                            <Link to={`/play/${gameData.path}/mycurrency`}>
                                <button 
                                    className='count-div g-button small-btn currency-div' >
                                    <ImageContainer 
                                        src='/images/icons/coin.png' 
                                        className='icon' 
                                    />
                                    <div className='count'>
                                        {formatNumber(playerData.currency)}
                                    </div>
                                </button>
                            </Link>
                        }
                    </div>
                    <button className='head-user-info g-button text-only' onClick={() => setShowDropdown(!showDropdown)}>
                        {
                            (currentUser && userProfile) &&
                            <>
                                {/* <div>{userProfile.fName}{userProfile.lName ? ` ${userProfile.lName}` : ''}</div> */}
                                <div className='user-icon' title={userProfile.name}>
                                    <UserIcon profile={userProfile} reverse={true} planIcon={true} />
                                </div>

                            </>
                            
                        }
                    </button>
                </div>
                <UserDropdown show={showDropdown} />
            </div>
            <div className={`play-mobile-header__menu-items ${menuOpen ? "show": ""}`}>
                <div className='close-button' onClick={() => setMenuOpen(!menuOpen)}>
                    <FontAwesomeIcon icon={faX} size='xl' />
                </div>
                <div className={`sidebar-left-container ${screenSize}`}>
                    <div className='sidebar-game-header'>
                        <ImageContainer 
                            src={gameData.header} 
                            className='icon' 
                        />
                    </div>
                    <div className="g-space-1"></div>
                    <PlayerSideMenu 
                        gameData={gameData}
                        playerData={playerData}
                        playerActivity={playerActivity}
                        gameElements={gameElements} />
                </div>
            </div>

            <div className='mobile-bottom-menu'>
                <Link to={`/play/${gameData.path}`}>
                    <button className={`g-button text-only ${
                        location.pathname === `/play/${gameData.path}` ? 'active' : ''
                    }`}>
                        <FontAwesomeIcon 
                            icon={faHome} 
                            size='xl' />
                    </button>
                </Link>
                {
                    (gameData && gameData.access.includes('items')) && 
                    <Link to={`/play/${gameData.path}/inventory`}>
                        <button className={`g-button text-only ${
                            location.pathname === `/play/${gameData.path}/inventory` ? 'active' : ''
                        }`}>
                            <FontAwesomeIcon 
                                icon={faToolbox} 
                                size='xl' />
                        </button>
                    </Link>
                }
                <div className='notification-with-badge'>
                    <Link to={`/play/${gameData.path}/rewards`}>
                        <button className={`g-button text-only ${
                            location.pathname === `/play/${gameData.path}/rewards` ? 'active' : ''
                        }`}>
                            <FontAwesomeIcon 
                                icon={faGem} 
                                size='xl' />
                        </button>
                    </Link>
                    {
                        rewardCount > 0 &&
                        <div className='badge'>{rewardCount}</div>
                    }
                </div>
                {
                    (gameData && gameData.access.includes('store')) &&
                    <Link to={`/play/${gameData.path}/marketplace`}>
                        <button className={`g-button text-only ${
                            location.pathname === `/play/${gameData.path}/marketplace` ? 'active' : ''
                        }`}>
                            <FontAwesomeIcon 
                                icon={faShoppingCart} 
                                size='xl' />
                        </button>
                    </Link>
                }
                {
                    (gameData && gameData.access.includes('challenges')) &&
                    <Link to={`/play/${gameData.path}/challenges`}>
                        <button className={`g-button text-only ${
                            location.pathname === `/play/${gameData.path}/challenges` ? 'active' : ''
                        }`}>
                            <FontAwesomeIcon 
                                icon={faFlag} 
                                size='xl' />
                        </button>
                    </Link>
                }
                {
                    (
                        gameData && 
                        gameData.access.includes('leaderboards') &&
                        gameElements &&
                        Object.values(gameElements)
                        .filter(e => e.type === 'leaderboard').length > 0
                    ) &&
                    <Link to={`/play/${gameData.path}/leaderboards`}>
                        <button className={`g-button text-only ${
                            location.pathname === `/play/${gameData.path}/leaderboards` ? 'active' : ''
                        }`}>
                            <FontAwesomeIcon 
                                icon={faRectangleList} 
                                size='xl' />
                        </button>
                    </Link>
                }
            </div>
        </div>
    )
}

export default PlayHeadBarMobile;